/* Rozbalovací výběr varianty (aktin pattern). Výběr samotný řeší Dawn:
   radio change → product-info.js přerenderuje celý <variant-selects>,
   takže nová instance se vrátí zavřená s aktuální variantou v kartě.
   Tento element jen přepíná atribut [open]. */
if (!customElements.get('variant-dropdown')) {
  customElements.define(
    'variant-dropdown',
    class VariantDropdown extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') this.close();
        });
        this.onDocumentClick = (event) => {
          if (this.hasAttribute('open') && !this.contains(event.target)) {
            this.close();
          }
        };
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      /* Otevřením vypadne seznam z toku (position: absolute) a box by se
         smrskl o výšku karty → obsah pod ním by poskočil. Box si proto
         před otevřením zafixuje svou zavřenou výšku. */
      open() {
        const box = this.querySelector('.pdp-vd__box');
        if (box) box.style.minHeight = `${box.offsetHeight}px`;
        this.setAttribute('open', '');
      }

      close() {
        this.removeAttribute('open');
        const box = this.querySelector('.pdp-vd__box');
        if (box) box.style.minHeight = '';
      }

      onClick(event) {
        if (event.target.closest('.pdp-vd__more')) {
          this.open();
          return;
        }
        const row = event.target.closest('.pdp-vd__row');
        if (!row) return;

        if (!this.hasAttribute('open')) {
          event.preventDefault();
          this.open();
          return;
        }

        const input = document.getElementById(row.getAttribute('for'));
        if (input && input.checked) {
          event.preventDefault();
        }
        this.close();
      }
    }
  );
}
